import { jsPDF } from "jspdf";

const clean = (v) => String(v ?? "").replace(/[^\x20-\x7E\u00A0-\u00FF\n]/g, "").replace(/\s+/g, " ").trim();

export function downloadReportPdf(report, formData) {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const W = doc.internal.pageSize.getWidth();
  const H = doc.internal.pageSize.getHeight();
  const M = 48;
  let y = 0;

  const ensure = (h) => { if (y + h > H - 56) { doc.addPage(); y = M; } };
  const heading = (txt) => {
    ensure(40); y += 14;
    doc.setFont("helvetica", "bold").setFontSize(12).setTextColor(184, 134, 11);
    doc.text(txt.toUpperCase(), M, y);
    doc.setDrawColor(255, 193, 7).setLineWidth(1).line(M, y + 5, W - M, y + 5);
    y += 22;
  };
  const para = (txt, label) => {
    const body = clean(txt);
    if (!body) return;
    doc.setFontSize(10.5).setTextColor(40, 40, 40);
    const lines = doc.splitTextToSize(label ? `${label}: ${body}` : body, W - M * 2);
    lines.forEach((ln, i) => {
      ensure(15);
      if (label && i === 0) {
        doc.setFont("helvetica", "bold").text(`${label}:`, M, y);
        doc.setFont("helvetica", "normal").text(ln.slice(label.length + 1), M + doc.getTextWidth(`${label}:`), y);
      } else doc.setFont("helvetica", "normal").text(ln, M, y);
      y += 15;
    });
    y += 6;
  };
  const row = (label, value) => {
    ensure(20);
    doc.setFont("helvetica", "normal").setFontSize(10.5).setTextColor(60, 60, 60).text(label, M, y);
    doc.setFont("helvetica", "bold").setTextColor(20, 20, 20).text(clean(value), W - M, y, { align: "right" });
    doc.setDrawColor(235).setLineWidth(0.5).line(M, y + 6, W - M, y + 6);
    y += 20;
  };

  doc.setFillColor(255, 193, 7).rect(0, 0, W, 86, "F");
  doc.setFont("helvetica", "bold").setFontSize(22).setTextColor(30, 30, 30).text("Vishu Astro", M, 42);
  doc.setFont("helvetica", "normal").setFontSize(11).text("Premium Astrology Report", M, 62);
  y = 118;
  doc.setFontSize(11).setTextColor(40, 40, 40);
  doc.setFont("helvetica", "bold").text(clean(formData.name), M, y);
  doc.setFont("helvetica", "normal").text(`DOB: ${clean(formData.birth_date)}   |   Zodiac: ${clean(report.zodiac)}`, M, y + 16);
  y += 26;

  heading("Scores");
  [["Love", report.love_score], ["Career", report.career_score], ["Wealth", report.wealth_score],
   ["Marriage", report.marriage_score], ["Health", report.health_score], ["Personality", report.personality_score]]
    .forEach(([l, v]) => row(l, `${v}%`));

  heading("Lucky Elements");
  row("Lucky Numbers", (report.lucky_numbers || []).join(", "));
  row("Lucky Colour", report.lucky_color);
  row("Lucky Day", report.lucky_day);

  heading("Personality & Traits (Deep)");
  para(report.deep_strength, "Strength");
  para(report.deep_weakness, "Weakness");
  heading("Love & Compatibility");
  para(report.relationship_deep);
  heading("Money Secret & Blockages");
  para(report.money_secret);
  para(report.money_blockage, "Blockage");
  heading("Aura & Energy");
  para(report.aura_energy);

  if (report.numerology) {
    heading("Numerology Breakdown");
    row("Life Path Number", report.numerology.life_path_number);
    row("Birth Day Number", report.numerology.birth_day_number);
    row("Destiny Number", report.numerology.destiny_number);
    para(report.numerology.life_path_meaning);
  }
  if (report.five_year_timeline?.length) {
    heading("5-Year Future Timeline");
    report.five_year_timeline.forEach((t) => para(t.theme, String(t.year)));
  }
  heading("Hidden Talent & Life Path");
  para(report.hidden_talent, "Talent");
  para(report.life_path, "Life Path");

  const pages = doc.getNumberOfPages();
  for (let i = 1; i <= pages; i++) {
    doc.setPage(i);
    doc.setFont("helvetica", "normal").setFontSize(8.5).setTextColor(140);
    doc.text(`Generated by Vishu Astro  -  vishuastro.in   |   Page ${i} of ${pages}`, W / 2, H - 28, { align: "center" });
  }
  const safeName = clean(formData.name).replace(/[^a-zA-Z0-9]+/g, "_") || "Report";
  doc.save(`VishuAstro_${safeName}_Premium_Report.pdf`);
}
